import { UIPanel } from '@/components/assets/js/libs/ui.js';

//import { MenubarAdd } from './Menubar.Add.js';
import { MenubarLogo } from './Menubar.Logo.js';
import { MenubarEdit } from './Menubar.Edit.js';// eslint-disable-line no-unused-vars
import { MenubarFile } from './Menubar.File.js';
//import { MenubarExamples } from './Menubar.Examples.js';
import { MenubarView } from './Menubar.View.js';
import { MenubarHelp } from './Menubar.Help.js';
import { MenubarRemote } from './Menubar.Remote.js';
import { MenubarStatus } from './Menubar.Status.js';

function Menubar( editor ) {

	const container = new UIPanel();
	container.setId( 'menubar' );
	if (window.Viewmode === "WebManual")
	{
		container.setHeight('60px'); 
	}


	container.add( new MenubarLogo() );
	container.add( new MenubarFile( editor ) );
	//container.add( new MenubarEdit( editor ) );
	//container.add( new MenubarAdd( editor ) );
	//container.add( new MenubarExamples( editor ) );
	container.add( new MenubarView( editor ) );
	container.add( new MenubarHelp( editor ) );
	container.add( new MenubarRemote( editor ) );

	container.add( new MenubarStatus( editor ) );

	return container;

}

export { Menubar };
